export type CouponDiscountType = 'percentage' | 'fixed';
export type CouponStatusFilter = 'all' | 'active' | 'inactive';

export interface Coupon {
  id: string;
  code: string;
  description: string;
  discountType: CouponDiscountType;
  discountValue: number;
  minOrderAmount?: number;
  maxDiscountAmount?: number;
  usageLimit?: number;
  usageCount: number;
  perUserLimit?: number;
  startsAt?: string;
  expiresAt?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedCoupons {
  results: Coupon[];
  total: number;
  page: string | number;
  limit: string | number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface CouponListParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  status?: 'active' | 'inactive';
  discountType?: CouponDiscountType;
}

export interface CreateCouponPayload {
  code?: string;
  description?: string;
  discountType: CouponDiscountType;
  discountValue: number;
  minOrderAmount?: number;
  maxDiscountAmount?: number;
  usageLimit?: number;
  perUserLimit?: number;
  startsAt?: string;
  expiresAt?: string;
  isActive?: boolean;
}

export type UpdateCouponPayload = Partial<CreateCouponPayload>;

export interface BulkCouponIdsPayload {
  ids: string[];
}

export interface BulkCouponStatusPayload extends BulkCouponIdsPayload {
  isActive: boolean;
}

export const COUPON_DISCOUNT_TYPE_OPTIONS = [
  { label: 'Percentage', value: 'percentage' as const },
  { label: 'Fixed amount', value: 'fixed' as const },
];
